import {
  SavedItemActionTypes,
  SavedItemState,
  LOADING_USER_SAVED_ITEMS,
  LOADED_USER_SAVED_ITEMS,
  SavedItemLoadingStatus,
  DELETING_SAVED_ITEMS,
  DELETED_SAVED_ITEMS
} from './types';
import { SAVED_TRENDING_TOPIC } from '../content/types';
import {
  SavedItemType,
  SavedItemViewModel
} from '../../model/saveditems/types';

const initialState = {
  status: SavedItemLoadingStatus.Uninitialized,
  items: {
    [SavedItemType.Documents]: {
      updating: false,
      items: [] as SavedItemViewModel[]
    },
    [SavedItemType.Topics]: {
      updating: false,
      items: [] as SavedItemViewModel[]
    },
    [SavedItemType.Searches]: {
      updating: false,
      items: [] as SavedItemViewModel[]
    }
  }
};

const reducer = (
  state: SavedItemState = initialState,
  action: SavedItemActionTypes
): SavedItemState => {
  switch (action.type) {
    case SAVED_TRENDING_TOPIC: {
      if (state.items.Topics.items.length > 0) {
        return {
          ...state,
          items: {
            ...state.items,
            [SavedItemType.Topics]: {
              ...state.items[SavedItemType.Topics],
              items: [
                ...state.items[SavedItemType.Topics].items,
                {
                  id: action.payload.termSetMapId,
                  description: action.payload.description,
                  url: action.payload.url,
                  markedForDeletion: false
                }
              ]
            }
          }
        };
      }

      return {
        ...state,
        status: SavedItemLoadingStatus.Uninitialized
      };
    }

    case LOADING_USER_SAVED_ITEMS: {
      return {
        status: SavedItemLoadingStatus.Loading,
        items: {
          ...initialState.items
        }
      };
    }

    case LOADED_USER_SAVED_ITEMS: {
      return {
        ...action.payload
      };
    }

    case DELETING_SAVED_ITEMS: {
      return {
        ...state,
        items: {
          ...state.items,
          [action.payload]: {
            ...state.items[action.payload],
            updating: true
          }
        }
      };
    }

    case DELETED_SAVED_ITEMS: {
      return {
        ...state,
        items: {
          ...state.items,
          [action.payload.type]: action.payload
        }
      };
    }
  }

  return state;
};
export default reducer;
